import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, App } from 'ionic-angular';
// import { LoginPage } from '../login/login';

/**
 * Generated class for the HuwonpopPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-huwonpop',
	templateUrl: 'huwonpop.html',
})
export class HuwonpopPage {
	loginEmail: string;
	items: any = [];

	language: string;
    texts: any = [];

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public app: App,
		public viewCtrl: ViewController
	) {
		this.items = this.navParams.get('items');
	}

	ionViewDidLoad() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		// this.loginEmail = localStorage.getItem("loginEmail");
        // if(!this.loginEmail) {
        //     this.app.getRootNav().setRoot(LoginPage);
        // }

        //// 페이지 이름
        localStorage.setItem("pageName", "huwonpop");
        this.language = localStorage.getItem("language");
        this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).huwonpop || {};
	}

	close() {
		this.viewCtrl.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/pages/huwonpop/huwonpop.ts